import React from "react";
import { IndexRedirect, Route } from "react-router";

import TabBar from "../TabBar";
import Search from './pages/Search';
import GeoView from './pages/GeoView';

const Home = props => {
  return (
    <div className='inner-section-root'>
      <TabBar
        items={[
          { to: `/images/geoview`, label: 'Geo View' },
          { to: `/images/search`, label: 'Search' },
        ]}
      />
      <div className='inner-section-content'>
        {props.children}
      </div>
    </div>
  );
};

const routes = () => (
  <Route component={Home} name={'view image'}>
    <IndexRedirect to='geoview' />
    <Route path='search' component={Search} />
    <Route path='geoview' component={GeoView} />
  </Route>
);

export default routes;


// WEBPACK FOOTER //
// ./src/components/Images/routes.js